import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ReadingListDto } from '../../services/dtos/readingList/readingList.dto';
import { updateReadingList } from '../../services/readingList/readingList.service';
import { Channels } from '../../utils/channels';
import { queryKeys } from '../queryKeyFactory';

export default (): UseMutationResult<void, void, ReadingListDto, void> => {
  const queryClient = useQueryClient();

  return useMutation(async (readingList: ReadingListDto) => {
    await updateReadingList(readingList);
    queryClient.invalidateQueries([queryKeys.fetchReadingLists.all]);
    Channels.readingListChannel.postMessage(null);
  });
};
